<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,24C1.009,24,0,22.991,0,21.75V5.25C0,4.009,1.009,3,2.25,3H6V0.75C6,0.336,6.336,0,6.75,0S7.5,0.336,7.5,0.75V3h9
		V0.75C16.5,0.336,16.836,0,17.25,0S18,0.336,18,0.75V3h3.75C22.991,3,24,4.009,24,5.25v16.5c0,1.241-1.009,2.25-2.25,2.25H2.25z
		 M1.5,21.75c0,0.414,0.336,0.75,0.75,0.75h19.5c0.414,0,0.75-0.336,0.75-0.75V10.5h-21V21.75z M22.5,9V5.25
		c0-0.414-0.336-0.75-0.75-0.75H18V6c0,0.414-0.336,0.75-0.75,0.75S16.5,6.414,16.5,6V4.5h-9V6c0,0.414-0.336,0.75-0.75,0.75
		S6,6.414,6,6V4.5H2.25C1.836,4.5,1.5,4.836,1.5,5.25V9H22.5z"/>
	<path d="M11.25,20.25c-0.2,0-0.389-0.078-0.53-0.22l-3-3c-0.292-0.292-0.292-0.768,0-1.061c0.142-0.142,0.33-0.22,0.53-0.22
		s0.389,0.078,0.53,0.22l2.389,2.389l3.981-5.309c0.141-0.188,0.366-0.3,0.6-0.3c0.163,0,0.319,0.052,0.449,0.15
		c0.331,0.249,0.398,0.719,0.15,1.05l-4.5,6c-0.131,0.174-0.33,0.283-0.547,0.298C11.288,20.249,11.269,20.25,11.25,20.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'calendar-check',
    },
    name: {
      type: String,
      required: false,
      default: 'CalendarCheck',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>